import { BarChart } from '@tremor/react';
import { ChartConfig } from './types';
import { AvailableChartColors } from '../../lib/chartUtils';

interface CindraBarChartProps {
  config: ChartConfig;
}

export function CindraBarChart({ config }: CindraBarChartProps) {
  const valueFormatter = config.valueFormatter
    ? (new Function('value', `return ${config.valueFormatter}`) as (value: number) => string)
    : undefined;

  return (
    <div className="w-full">
      <BarChart
        categories={config.categories}
        className="h-80"
        colors={AvailableChartColors}
        data={config.data}
        index={config.index}
        showAnimation={true}
        showLegend={config.categories.length > 1}
        stack={false}
        valueFormatter={valueFormatter}
        yAxisWidth={56}
      />
    </div>
  );
}
